import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { baseAdministrationActions, baseAdministrationSelectors, BaseCoreState } from '../../../_store';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class BaseOrganizationManagementGuard {
  constructor(private store: Store<BaseCoreState>) {}

  canActivate(): Observable<boolean> {
    this.store.dispatch(baseAdministrationActions.loadLocationsData({ payload: { isActive: true } }));

    return this.store.select(baseAdministrationSelectors.getLocationsData).pipe(
      filter((state) => !!state.ok),
      map((state) => state.ok as boolean)
    );
  }
}
